module.exports = __webpack_public_path__ + "img/acquisitions-incorporated.7bcccbcf.svg";